import React, { useEffect, useState } from 'react';
export function UrgencySection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: '23',
    minutes: '59',
    seconds: '59'
  });
  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const endTime = new Date(now);
      endTime.setHours(23, 59, 59, 0);
      if (now > endTime) endTime.setDate(endTime.getDate() + 1);
      const diff = endTime.getTime() - now.getTime();
      setTimeLeft({
        hours: String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0'),
        minutes: String(Math.floor(diff % (1000 * 60 * 60) / (1000 * 60))).padStart(2, '0'),
        seconds: String(Math.floor(diff % (1000 * 60) / 1000)).padStart(2, '0')
      });
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  return <section className="py-8 px-5 bg-urgency-gradient text-center" data-id="element-164">
      <div className="max-w-[650px] mx-auto border-2 border-dorado rounded-2xl p-6 bg-[rgba(212,175,55,0.05)]" data-id="element-165">
        <h2 className="font-playfair text-[clamp(20px,3vw,28px)] text-dorado mb-3" data-id="element-166">
          ⚠️ Este Precio de Lanzamiento No Dura Para Siempre
        </h2>
        <p className="text-[14px] text-[#cccccc] mb-4 leading-[1.6]" data-id="element-167">
          Cuando el contador llegue a cero, el precio vuelve a{' '}
          <strong className="text-dorado" data-id="element-168">$35.000 ARS</strong>. Tu única
          oportunidad al precio más bajo.
        </p>
        <div className="flex justify-center gap-4 mb-5" data-id="element-169">
          {[{
          value: timeLeft.hours,
          label: 'Horas'
        }, {
          value: timeLeft.minutes,
          label: 'Min'
        }, {
          value: timeLeft.seconds,
          label: 'Seg'
        }].map((item, i) => <div key={i} className="bg-negro border-2 border-dorado rounded-xl py-2.5 px-4 min-w-[65px]" data-id="element-170">
              <span className="font-playfair text-[30px] font-black text-dorado block leading-none" data-id="element-171">
                {item.value}
              </span>
              <span className="text-[10px] text-[#888] tracking-[1px] uppercase" data-id="element-172">
                {item.label}
              </span>
            </div>)}
        </div>
        <a href="https://pagos.indigo33.shop/cart/44022797729880:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-cta text-negro py-3.5 px-8 rounded-[60px] text-[clamp(15px,2vw,18px)] font-black no-underline tracking-[1px] transition-all duration-400 shadow-[0_15px_40px_rgba(212,175,55,0.4)] animate-pulse-cta uppercase cursor-pointer border-none hover:-translate-y-[3px] hover:scale-[1.03]" data-id="element-173">
          💎 APROVECHAR PRECIO DE LANZAMIENTO →
        </a>
      </div>
    </section>;
}